/*
 * File: cell-organization-name.ts
 * Created: 2026-01-19 15:20:00
 * Author: Val Liu <valuis0429@gmail.com>
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

const palette = [
    { bg: "#e3f2fd", color: "#0097a7" },
    { bg: "#f3e5f5", color: "#8e24aa" },
    { bg: "#e8f5e9", color: "#2e7d32" },
    { bg: "#fff3e0", color: "#ef6c00" },
    { bg: "#ede7f6", color: "#5e35b1" },
];

@Component
export default class CellOrganizationName extends BaseTableBodyCell {
    get displayName(): string {
        const name =
            this.value ??
            this.row?.name ??
            this.row?.organization?.name ??
            this.row?.organizationName;
        return name == null ? "" : String(name);
    }

    get orgId(): string {
        const id = this.row?.organization?.id ?? this.row?.id;
        return id == null ? "" : String(id);
    }

    get avatarText(): string {
        const name = this.displayName.trim();
        if (!name) return "?";
        return name[0].toUpperCase();
    }

    get avatarStyle() {
        const seed = this.avatarText.charCodeAt(0) || 0;
        const idx = seed % palette.length;
        return {
            backgroundColor: palette[idx].bg,
            color: palette[idx].color,
        };
    }
}
